import { defineMessages } from '@formatjs/intl';

export default defineMessages({
	heading: {
		id: 'subpage.sleep.unlock.heading',
		defaultMessage: 'Just press play and drift away.',
		description: 'Heading for the sleep category page unlock section',
	},
	body: {
		id: 'subpage.sleep.unlock.body',
		defaultMessage:
			'Our 300+ Sleep Stories, sleep meditations, and calming music will guide you off to sleep quickly and naturally.',
		description: 'Body text for the sleep category page unlock section',
	},
});
